module.exports = __webpack_public_path__ + "static/img/draw_wheel.80e6a56.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/draw_wheel.png
// module id = 563
// module chunks = 1